import { Button } from '@/components/shadcn/button'
import {
  DropdownMenuSeparator,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { IconHeaderOutline, IconPinOutline } from '@/components/icons'
import { TPageFilter } from '../types'

export function PinFilterMenu({
  filter,
  pinFilter,
}: {
  filter?: TPageFilter
  pinFilter: (selectedF: TPageFilter, side: 'left' | 'right') => void
}) {
  if (!filter) return null
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="rounded-full p-0">
          <IconPinOutline className="size-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>
          <IconPinOutline className="mr-2 size-4" />
          <span>Pin filter to header</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem onSelect={() => pinFilter(filter, 'left')}>
            <IconHeaderOutline className="size-4 -rotate-90" />
            <span>Left</span>
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => pinFilter(filter, 'right')}>
            <IconHeaderOutline className="size-4 rotate-90" />
            <span>Right</span>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
